import { css } from '@emotion/react'
import React from 'react'

export const Cover: React.FC<{
  handleClick: () => void
  zIndex?: number
  background?: string
}> = (props) => {
  return (
    <div
      css={css`
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
        position: fixed;
        background-color: ${props.background || 'transparent'};
        width: 100%;
        height: 100%;
        z-index: ${props.zIndex || 1}};
      `}
      className="cover"
      onClick={props.handleClick}
    />
  )
}
